const beforeEach = (to, from, next) => {
  const setDocumentTitle = (route) => {
    document.title = `${route.meta.tit}_WayPal英语—大阅读为伴，好英语自来`;
    const ua = navigator.userAgent;
    if (/\bMicroMessenger\/([\d.]+)/.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
      const i = document.createElement('iframe');
      i.src = '/favicon.ico';
      i.style.display = 'none';
      i.onload = () => {
        setTimeout(() => {
          i.remove();
        }, 9);
      };
      document.body.appendChild(i);
    }
  };
  setDocumentTitle(to);
  next();
};

export default beforeEach;



// WEBPACK FOOTER //
// ./src/router/BeforeEach.js